// extracted by mini-css-extract-plugin
export default {"cls1":"AutoCompleteResults-cls1__fd047394531953b7c9a9","cls2":"AutoCompleteResults-cls2__b0a31624e1608d6b29f5 AutoCompleteResults-cls1__fd047394531953b7c9a9"};